import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { OrderListItemModel } from '../../models/order/order-list-item.model';
import { Observable } from 'rxjs';
import { NewOrderModel } from '../../models/order/new-order.model';
import { OrderNumber, TaskResult } from '../../models/client-models';
import { OrderListParameters } from '../../models/client-models';

const ORDER_ENDPOINT = 'order';

@Injectable({
  providedIn: 'root',
})
export class OrderBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Get order list form backend with paging and filter.
   *
   * @param orderParams filter and paging and personID
   */
  public getOrderList(orderParams: OrderListParameters) {
    return this.http.post<OrderListItemModel[]>(
      AppConfig.settings.backend.url + ORDER_ENDPOINT,
      orderParams
    );
  }

  /**
   * Get order information by id.
   *
   * @param orderID
   */
  public getOrderByID(orderID: number): Observable<OrderListItemModel> {
    return this.http.get<OrderListItemModel>(
      AppConfig.settings.backend.url +
        ORDER_ENDPOINT +
        '/byID' +
        '?orderID=' +
        orderID
    );
  }

  /**
   * Get next order number.
   */
  public getNextOrderNumber(): Observable<OrderNumber> {
    return this.http.get<OrderNumber>(
      AppConfig.settings.backend.url + ORDER_ENDPOINT + '/counter'
    );
  }

  /**
   * Check if order number is free.
   *
   * @param orderNumber
   */
  public checkOrderNumber(orderNumber: string): Observable<TaskResult> {
    return this.http.get<TaskResult>(
      AppConfig.settings.backend.url +
        ORDER_ENDPOINT +
        '/validNewNumber?orderNumber=' +
        orderNumber
    );
  }

  /**
   * Save new order.
   *
   * @param newOrder new order infos.
   */
  public saveNewOrder(newOrder: NewOrderModel): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + ORDER_ENDPOINT + '/new/',
      newOrder
    );
  }

  public calculateAksPlan(orderId: number): Observable<TaskResult> {
    const url = new URL(
      AppConfig.settings.backend.url + ORDER_ENDPOINT + '/calcAKSPlan'
    );
    const params = new URLSearchParams();
    params.append('auftragID', orderId.toString()); // Ensure orderId is converted to string
    url.search = params.toString();
    const requestBody = { orderId };

    return this.http.post<TaskResult>(url.toString(), requestBody);
  }
}
